<template>
  <div class="app-container">
    <el-form :model="queryParams" class="multipleSelectScroll" ref="queryForm" v-show="showSearch" label-width="80px">
      <el-row :gutter="10" class="mb8">
        <el-col :xs="24" :md="12" :lg="6">
          <el-form-item label="订单编号" prop="orderNum">
            <el-input v-model="queryParams.orderNum" placeholder="请输入订单编号" clearable/>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :md="12" :lg="6">
          <el-form-item label="客户名称" prop="customerName">
            <el-input v-model="queryParams.customerName" placeholder="请输入客户名称" clearable/>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :md="12" :lg="6">
          <el-form-item label="商机名称" prop="businessName">
            <el-input v-model="queryParams.businessName" placeholder="请输入商机名称" clearable/>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :md="12" :lg="6">
          <el-form-item label="合同编号" prop="contractNum">
            <el-input v-model="queryParams.contractNum" placeholder="请输入合同编号" clearable/>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :md="12" :lg="6">
          <el-form-item label="交付日期" prop="deliveryDate">
            <el-date-picker v-model="queryParams.deliveryDate" value-format="yyyy-MM-dd" type="daterange" range-separator="-" style="width:100%" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :md="12" :lg="6">
          <el-form-item label="订单状态" prop="orderStatusList">
            <el-select v-model="queryParams.orderStatusList" placeholder="请选择订单状态" clearable multiple style="width:100%">
              <el-option v-for="dict in statusOptions" :key="dict.dictValue" :label="dict.dictLabel" :value="dict.dictValue" multiple/>
            </el-select>
          </el-form-item>
        </el-col>
        <dept-user-select ref="deptUserSelectRef" :formParam="queryParams"></dept-user-select>
        <el-col :xs="24" :md="24" :lg="24" align="right">
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="handleQuery">搜索</el-button>
            <el-button icon="el-icon-refresh" @click="resetQuery">清空</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <el-row :gutter="10" class="mb8">
      <el-col :span="1.5">
        <el-button type="primary" icon="el-icon-plus" @click="handleAdd">新增</el-button>
      </el-col>
      <el-col :span="1.5">
        <el-button type="primary" icon="el-icon-user" :disabled="multiple" @click="handleAssign">分配</el-button>
      </el-col>
      <right-toolbar :showSearch.sync="showSearch" @queryTable="getList"></right-toolbar>
    </el-row>
    <el-row>
        <el-col :xs="24" :md="6" :lg="4">
            <div style="font-size: 14px; margin: 10px 0">
                订单数量：{{total}}
            </div>
        </el-col>
        <el-col :xs="24" :md="6" :lg="4">
            <div style="font-size: 14px; margin: 10px 0">
                合同总金额（元）：{{amountFormat(Number(otherData.totalContractAmount || 0) / 10000)}}万元
            </div>
        </el-col>
    </el-row>
    <el-table v-loading="loading" :data="dataList" @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="55" fixed="left" align="center"/>
      <el-table-column label="订单编号" min-width="100" align="left">
        <template slot-scope="scope">
          <el-link type="primary" class="crm-link-wrap" :underline="false" @click="$jump.deliver(scope.row.id, '_blank')">{{scope.row.orderNum}}</el-link>
        </template>
      </el-table-column>
      <el-table-column label="订单状态" align="left" prop="orderStatusDesc">
      </el-table-column>
      <el-table-column label="客户" align="center">
          <template slot-scope="scope">
            <el-link type="primary" class="crm-link-wrap" :underline="false" @click="$jump.customer(scope.row.customerId, '_blank')">{{scope.row.customerName}}</el-link>
          </template>
      </el-table-column>
      <el-table-column label="商机" align="center" prop="businessScaleDesc">
          <template slot-scope="scope">
            <el-link type="primary" class="crm-link-wrap" :underline="false" @click="$jump.business(scope.row.businessId, '_blank')">{{scope.row.businessName}}</el-link>
          </template>
      </el-table-column>
      <el-table-column label="合同编号" align="center">
        <template slot-scope="scope">
            <el-link type="primary" class="crm-link-wrap" :underline="false" @click="$jump.contract(scope.row.contractId, '_blank')">{{scope.row.contractNum}}</el-link>
          </template>
      </el-table-column>
      <el-table-column label="合同金额(元)" xalign="center" prop="estimateDealAmount">
        <template slot-scope="scope">
          <span>{{ amountFormat(Number(scope.row.contractAmount || 0)/ 10000) }}万</span>
        </template>
      </el-table-column>
      <el-table-column label="发货日期" align="center" prop="expressDate"/>
      <el-table-column label="交付日期" align="center" prop="deliveryDate"/>
      <el-table-column label="负责人" align="center" prop="managerName"/>
      <el-table-column label="操作" width="110" align="center" fixed="right" class-name="small-padding fixed-width">
        <template slot-scope="scope">
          <el-button type="text"  @click="toDetail(scope.row)">查看</el-button>
          <el-button v-if="scope.row.orderStatus === 10" type="text"  @click="handleExpress(scope.row)">发货</el-button>
          <el-button v-if="scope.row.orderStatus === 20" type="text"  @click="handleDelivery(scope.row)">确认交付</el-button>
        </template>
      </el-table-column>
    </el-table>

    <pagination v-show="total>0" :total="total" :page.sync="queryParams.pageNum" :limit.sync="queryParams.pageSize" @pagination="getList"/>

    <AssignDialog ref="assignDialogRef" @success="getList"></AssignDialog>
    <DeliveryOrderAddDialog ref="deliveryOrderAddDialogRef" @success="getList"></DeliveryOrderAddDialog>
    <!-- 发货 -->
    <AddExpressDialog ref="addExpressDialogRef" @success="getList"/>
    <!-- 确认交付 -->
    <ConfirmDeliverDialog ref="confirmDeliverDialogRef" @success="getList"></ConfirmDeliverDialog>

  </div>
</template>

<script>
import AssignDialog from "@/views/crm/components/assignDialog";
import DeliveryOrderAddDialog from "./deliveryOrderAddDialog"
import ConfirmDeliverDialog from "./confirmDeliverDialog"
import deptUserSelect from "@/views/crm/components/deptUserSelect";
import { mapState } from 'vuex'
import { amountFormat } from '@/utils/index'
import { getDicts } from "@/api/system/dict/data";
import { listDeliveryByPage } from "@/api/crm/order";
import AddExpressDialog from "./addExpressDialog.vue"

export default {
  name: "BusinessManage",
  data() {
    return {
      amountFormat,
      // 遮罩层
      loading: true,
      // 选中数组
      ids: [],
      // 非多个禁用
      multiple: true,
      // 显示搜索条件
      showSearch: true,
      // 总条数
      total: 0,
      dataList: [],
      otherData: {},
      statusOptions: [], // 订单状态
      // 查询参数
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        orderNum: null,
        customerName: null,
        businessName: null,
        contractNum: null,
        deliveryDate: [],
        orderStatusList: [],
        deptIdList: [],
        managerIdList: []
      }
    };
  },
  computed: {
    ...mapState({
      currentUserId: state => state.user.userId
    })
  },
  components: {
    AssignDialog,
    DeliveryOrderAddDialog,
    ConfirmDeliverDialog,
    deptUserSelect,
    AddExpressDialog
  },
  created() {
    if (!this.$route.query.isAll) {
      this.queryParams.managerIdList = [this.currentUserId]
    }
    // this.getList();
    // delivery_order_status 交付单状态
    this.getDicts("delivery_order_status").then(response => {
      this.statusOptions = response.data;
    });
    this.handleQuery()
  },
  methods: {
    getList() {
      this.loading = true;
      let params = JSON.parse(JSON.stringify(this.queryParams));
      // 是否查看团队所在商机数据标志，默认不查看，目前只有列表入口会查看，其他跳转过来的不查
      let deliveryDate = this.queryParams.deliveryDate
      listDeliveryByPage({
          ...this.queryParams,
          deliveryDateStart: deliveryDate ? deliveryDate[0] : null,
          deliveryDateEnd: deliveryDate ? deliveryDate[1] : null
      }).then(response => {
          this.dataList = response.rows || []
          this.otherData = response.otherData || {}
          this.total = response.total;
          this.loading = false;
        }
      ).catch(error => {
        this.loading = false;
      });
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParams.pageNum = 1;
      this.getList();
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.resetForm("queryForm");
      this.$refs.deptUserSelectRef.deptSelect()
      this.handleQuery();
    },
    // 多选框选中数据
    handleSelectionChange(selection) {
      this.ids = selection.map(item => item.id);
      this.multiple = !selection.length;
    },
    /** 详细按钮操作 */
    toDetail(row) {
      window.open("/crm/deliveryOrder/detail/" + row.id, "_blank")
    },
    /** 详细按钮操作 */
    toCustomerDetail(row) {
      window.open("/crm/customer/detail/" + row.customerId, "_blank")
    },
    /** 新增按钮操作 */
    handleAdd() {
      this.$refs.deliveryOrderAddDialogRef.open();
    },
    // 发货
    handleExpress(row) {
        this.$refs.addExpressDialogRef.open(row.id)
    },
    // 确认交付
    handleDelivery(row) {
        this.$refs.confirmDeliverDialogRef.open(row.id)
    },
    /** 分配按钮操作 */
    handleAssign() {
      this.$refs.assignDialogRef.batchAssign("deliveryOrder", this.ids)
    }
  }
};
</script>
